function ChevronDownIcon({ className }) {
  return (
    <svg className={`ic ${className}`} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.1733 12.3866L16 17.5599L10.8266 12.3866C10.3066 11.8666 9.46664 11.8666 8.94664 12.3866C8.42664 12.9066 8.42664 13.7466 8.94664 14.2666L15.0666 20.3866C15.5866 20.9066 16.4266 20.9066 16.9466 20.3866L23.0666 14.2666C23.5866 13.7466 23.5866 12.9066 23.0666 12.3866C22.5466 11.8799 21.6933 11.8666 21.1733 12.3866V12.3866Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default ChevronDownIcon;
